import './bootstrap.js';
import jQuery from 'jquery';
import Dropzone from 'dropzone';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail/lg-thumbnail.es5.js';
import 'datatables.net-dt/js/dataTables.dataTables.min.js'; // Correct import for DataTables with Bootstrap 5
window.$ = window.jQuery = jQuery;
window.Dropzone = Dropzone;

if (document.querySelector("#eventImageUpload")) {
    new Dropzone("#eventImageUpload", {
        url: document.querySelector('#eventImageUpload').action,
        maxFiles: 1,
        maxFilesize: 5, // MB
        acceptedFiles: 'image/*',
        dictDefaultMessage: 'Kéo thả ảnh vào đây hoặc click để chọn ảnh có mặt bạn',
        headers: {
            'X-CSRF-TOKEN': document.querySelector('input[name="_token"]').value
        },
        init: function() {
            this.on("success", function(file, response) {
                var imageUrl = response.url;
                const event_url = document.querySelector('#eventImageUpload').getAttribute('data_url');
                window.location.href = event_url + '?filter=true&image=' + encodeURIComponent(imageUrl);
            });
            this.on("error", function(file, response) {
                alert(response);
            });
        }
    });
}


$(document).ready(function() {
    lightGallery(document.getElementById('lightgallery'), {
        plugins: [lgThumbnail],
        thumbHeight: '80px',
        allowMediaOverlap: false,
        toggleThumb: true,
        download: true,
        getCaptionFromTitleOrAlt: false,
        appendSubHtmlTo: '.lg-item',
        addClass: 'lg-fixed-size',
        selector: 'a',
        subHtmlSelectorRelative: true,
    });

    // File upload handling
    if (document.querySelector("#myDropzone")) {
        let totalFiles = 0;
        let uploadingFiles = 0;
        let successfulFiles = 0;
        let failedFiles = 0;

        const fileTable = $('#fileTable').DataTable({
            pageLength: 20,
        });

        function updateStats() {
            $('#totalFiles').text(totalFiles);
            $('#uploadingFiles').text(uploadingFiles);
            $('#successfulFiles').text(successfulFiles);
            $('#failedFiles').text(failedFiles);
        }

        new Dropzone("#myDropzone", {
            url: document.querySelector('#myDropzone').action,
            paramName: 'file',
            maxFilesize: 50,
            maxFiles: 1000,
            acceptedFiles: 'image/*',
            addRemoveLinks: true,
            dictDefaultMessage: 'Kéo và thả file vào đây để tải lên, hoặc click để chọn file',
            disablePreviews: true,
            init: function() {
                this.on("addedfile", function(file) {
                    totalFiles++;
                    uploadingFiles++;
                    updateStats();

                    fileTable.row.add([
                        fileTable.rows().count() + 1,
                        file.name,
                        (file.size / 1024).toFixed(2) + ' KB',
                        'Chưa tải lên'
                    ]).draw(false);

                    // Check if the current page is full and navigate to the next page
                    if (fileTable.page.info().end === fileTable.rows().count()) {
                        fileTable.page('next').draw('page');
                    }
                });

                this.on("uploadprogress", function(file, progress) {
                    const rowIndex = fileTable.rows().indexes().filter((idx) => {
                        return fileTable.cell(idx, 1).data() === file.name;
                    })[0];
                    fileTable.cell(rowIndex, 3).data(`Đang tải lên ${progress.toFixed(2)}%`).draw(false);
                });

                this.on("success", function(file, response) {
                    uploadingFiles--;
                    successfulFiles++;
                    updateStats();
                    const rowIndex = fileTable.rows().indexes().filter((idx) => {
                        return fileTable.cell(idx, 1).data() === file.name;
                    })[0];
                    fileTable.cell(rowIndex, 3).data('Hoàn thành').draw(false);

                    // Check if all files are successfully uploaded
                    if (uploadingFiles === 0 && (successfulFiles + failedFiles === totalFiles)) {
                        alert('Tất cả các tệp đã được xử lý!');
                    }
                });

                this.on("error", function(file, errorMessage) {
                    uploadingFiles--;
                    failedFiles++;
                    updateStats();
                    const rowIndex = fileTable.rows().indexes().filter((idx) => {
                        return fileTable.cell(idx, 1).data() === file.name;
                    })[0];
                    fileTable.cell(rowIndex, 3).data('Lỗi').draw(false);
                });

                this.on("removedfile", function(file) {
                    totalFiles--;
                    if ($(`tr[data-index="${file.name}"] .status`).text() === 'Đang tải lên') {
                        uploadingFiles--;
                    } else if ($(`tr[data-index="${file.name}"] .status`).text() === 'Hoàn thành') {
                        successfulFiles--;
                    } else if ($(`tr[data-index="${file.name}"] .status`).text() === 'Lỗi') {
                        failedFiles--;
                    }
                    updateStats();

                    const rowIndex = fileTable.rows().indexes().filter((idx) => {
                        return fileTable.cell(idx, 1).data() === file.name;
                    })[0];
                    fileTable.row(rowIndex).remove().draw(false);
                });
            }
        });
    }
});